module.exports = __webpack_public_path__ + "static/media/success(23).1b7f5060.png";